(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var banner = page.querySelector('[data-cart-moq]');
    var list = page.querySelector('[data-cart-moq-list]');
    var checkout = page.querySelector('[data-checkout]');
    var blocked = page.querySelector('[data-moq-blocked]');
    var template = page.getAttribute('data-moq-line') || '';
    var items = Array.prototype.slice.call(page.querySelectorAll('[data-cart-item]'));
    var subtotalEl = page.querySelector('[data-cart-subtotal]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function fill(str, v) {
      return str
        .replace('{needed}', v.needed)
        .replace('{current}', v.current)
        .replace('{minimum}', v.minimum);
    }

    function buildItem(v) {
      var li = document.createElement('li');
      li.className = 'cart-moq__item';
      var parts = template.split('{product}');
      li.appendChild(document.createTextNode(fill(parts[0] || '', v)));
      var strong = document.createElement('strong');
      strong.textContent = v.name;
      li.appendChild(strong);
      li.appendChild(document.createTextNode(fill(parts[1] || '', v)));
      return li;
    }

    function recompute() {
      var totals = {};
      var moqs = {};
      var names = {};
      var order = [];
      var subtotal = 0;

      items.forEach(function (item) {
        var pid = item.getAttribute('data-product-id');
        var moq = parseInt(item.getAttribute('data-moq'), 10) || 0;
        var input = item.querySelector('[data-moq-qty]');
        var qty = input ? parseInt(input.value, 10) : 0;
        if (isNaN(qty) || qty < 0) qty = 0;
        if (!(pid in totals)) {
          totals[pid] = 0;
          moqs[pid] = moq;
          names[pid] = item.getAttribute('data-product-title') || '';
          order.push(pid);
        }
        totals[pid] += qty;

        var lineEl = item.querySelector('[data-line-total]');
        if (lineEl) {
          var unit = parseInt(lineEl.getAttribute('data-unit-price'), 10) || 0;
          var lineTotal = unit * qty;
          lineEl.textContent = formatMoney(lineTotal);
          subtotal += lineTotal;
        }
      });

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);

      var violations = [];
      order.forEach(function (pid) {
        var moq = moqs[pid];
        if (moq > 0 && totals[pid] < moq) {
          violations.push({
            name: names[pid],
            current: totals[pid],
            minimum: moq,
            needed: moq - totals[pid]
          });
        }
      });

      var unmet = violations.length > 0;
      if (list) {
        list.innerHTML = '';
        violations.forEach(function (v) {
          list.appendChild(buildItem(v));
        });
      }
      if (banner) banner.hidden = !unmet;
      if (blocked) blocked.hidden = !unmet;
      if (checkout) checkout.disabled = unmet;
    }

    page.addEventListener('input', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-moq-qty')) {
        recompute();
      }
    });

    recompute();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function labelOf(btn) {
      return btn.tagName === 'INPUT' ? btn.value : btn.textContent;
    }
    function setLabel(btn, text) {
      if (btn.tagName === 'INPUT') {
        btn.value = text;
      } else {
        btn.textContent = text;
      }
    }
    function updateCount(n) {
      var el = document.querySelector('[data-cart-count]');
      if (!el) return;
      el.textContent = n;
      if (n > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('js-atc-form')) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.disabled) return;
      var original = btn ? labelOf(btn) : '';

      if (btn) {
        btn.disabled = true;
        setLabel(btn, btn.getAttribute('data-adding-label') || 'Adding…');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              updateCount(cart.item_count);
              if (btn) setLabel(btn, btn.getAttribute('data-added-label') || 'Added');
            });
        })
        .catch(function () {
          if (btn) setLabel(btn, btn.getAttribute('data-error-label') || 'Unavailable');
        })
        .then(function () {
          if (btn) {
            setTimeout(function () {
              btn.disabled = false;
              setLabel(btn, original);
            }, 1600);
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
